import { useNavigate } from "react-router-dom";

export default function EmptyState({ icon, text, sub, actionLabel, actionTo }) {
  const navigate = useNavigate();
  return (
    <div style={{ padding: "24px 16px", textAlign: "center", background: "var(--fc-bg-light)", border: "1.5px dashed var(--fc-border-strong)", borderRadius: 10 }}>
      <div style={{ width: 42, height: 42, borderRadius: 11, background: "var(--fc-border-light)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 10px" }}>
        <i className={`fa-solid ${icon}`} style={{ fontSize: 17, color: "var(--fc-text-hint)" }} />
      </div>
      <div style={{ fontSize: 13, fontWeight: 700, color: "var(--fc-text-muted)", marginBottom: 3 }}>{text}</div>
      {sub && <div style={{ fontSize: 11, color: "var(--fc-text-subtle)" }}>{sub}</div>}
      {actionLabel && actionTo && (
        <button onClick={() => navigate(actionTo)}
          style={{ marginTop: 12, background: "var(--fc-primary-light)", color: "var(--fc-primary)", border: "none", borderRadius: 99, padding: "6px 16px", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
